// extracted by mini-css-extract-plugin
module.exports = {"mainTitle":"SectionTitle_mainTitle__rNIsZ"};